export default function getIndexInLoopingArray (arrayLength, index) {
  if (index < 0) {
    if (-index % arrayLength === 0) return 0

    return arrayLength + index % arrayLength
  }

  return index % arrayLength
}
